import Exim from 'exim';
import Api from 'tm3-core/api';

const Tours = Exim.createStore({
  actions: ['preload', 'dontShowAgain'],

  initial() {
    return { tours: {} };
  },

  preload(tours) {
    return this.set({ tours });
  },

  dontShowAgain(name) {
    const tours = this.get('tours');
    tours[name] = true;
    this.set({ tours });
    return Api.put('/api/tours/skip', tours);
  }
});
export default Tours;
export { Tours };
